import React from 'react';
import { graphql } from 'gatsby';
import Img from 'gatsby-image';
import Layout from '../components/Layout';

export default ({ data }) => {
  return (
    <Layout>
      <h1
        css={`
          padding: 1rem;
          border-right: 1px solid black;
          border-bottom: 1px solid black;
        `}
      >
        {data.inventoryJson.name}
      </h1>
      <div
        css={`
          display: grid;
          grid-template-columns: 1fr 1fr;

          @media only screen and (max-width: 768px) {
              grid-template-columns: 1fr;
          }

          > * {
            border-right: 1px solid black;
            border-bottom: 1px solid black;
          }
        `}
      >
        <div
          css={`
            display: flex;
            flex-direction: column;

            > * {
              padding: 20%;
            }

            > * + * {
              border-top: 1px solid black;
            }
          `}
        >
          {data.inventoryJson.images.map((image) => {
            return (
              <div>
                <Img fluid={image.childImageSharp.fluid} />
              </div>
            );
          })}
        </div>
        <div
          css={`
            display: flex;
            flex-direction: column;

            > * {
              padding: 1rem;
            }

            > * + * {
              border-top: 1px solid black;
            }
          `}
        >
          <div
            css={`
              padding: 0;
              display: grid;
              grid-template-columns: 1fr 1fr;
              justify-content: space-between;

              > * {
                padding: 1rem;
              }
            `}
          >
            <span>
              {data.inventoryJson.listed_price
                ? `$${data.inventoryJson.listed_price}`
                : '$XXX'}
            </span>
            <a
              href="https://instagram.com/publio.official"
              target="blank"
              css={`
                background-color: #45db5d;
              `}
            >
              PURCHASE
            </a>
          </div>
          <p>CONDITION: {data.inventoryJson.condition}</p>
          <p>SIZE: {data.inventoryJson.size}</p>
          <p></p>
        </div>
      </div>
    </Layout>
  );
};

export const query = graphql`
  query($id: String!) {
    inventoryJson(id: { eq: $id }) {
      id
      is_women
      listed_price
      brand
      category
      condition
      created_at
      currency
      have_box
      name
      promised_price
      size
      release_year
      sold_price
      status
      images {
        id
        publicURL
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`;
